module.exports = __webpack_public_path__ + "static/media/8.080866f3.png";